module.exports = __webpack_public_path__ + "static/media/deer.82be4596.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/deer.png
// module id = 32
// module chunks = 0